import React, { useEffect, useState, useContext } from 'react';
import classes from './index.module.scss';
import { SearchContext } from '../../context/Search';

const PageSwitcher = () => {
  const { setForcePage, setOffset, pageCount, limit, offset } = useContext(SearchContext);
  const [gotoValue, setGotoValue] = useState(1);
  const [inputValue, setInputValue] = useState(1);

  const pageSwitchHandler = () => {
    if (!inputValue) {
      setGotoValue(1);
      setInputValue(1);
    } else {
      setGotoValue(inputValue);
    }
    window.scroll({top: 0, left: 0, behavior: 'smooth' })
  }

  useEffect(() => {
    setOffset(limit * (gotoValue - 1));
    setForcePage(gotoValue - 1);
  }, [gotoValue]);

  useEffect(() => {
    setInputValue(Math.ceil(offset / limit) + 1);
  }, [limit, offset])

  const onKeyUpHandler = (e) => {
    if (e.key === 'Enter' || e.keyCode === 13) pageSwitchHandler();
  }

  const onChangeHandler = (e) => {
    let value = e.target.value;

    value = value.match(/\d+/g);
    if (!value) value = "";
    if (value) value = value.join("");
    if (value && +value > +pageCount) value = pageCount;
    setInputValue(value);
  }

  return (
    <div className={classes.Page_Switcher_Wrap}>
      <p>Go to page</p>
      <input 
        className={classes.Page_Switcher_Input}
        onChange={onChangeHandler}
        onKeyUp={onKeyUpHandler}
        type="text" 
        value={inputValue}
      />
      <span
        onClick={pageSwitchHandler}
      >
        {"Go >"}
      </span>
    </div>
  )
}

export default PageSwitcher;